import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { Role } from "@/types/roles";

interface RoleRouteProps {
  allowedRoles: Role[];
  children: React.ReactElement;
}

const defaultDashboard = (role?: string): string => {
  switch (role) {
    case Role.ADMIN:
      return "/admin/dashboard";
    case Role.SALES_AGENT:
      return "/all-appointments";
    case Role.CALLING_AGENT:
      return "/auto-dialer";
    default:
      return "/login";
  }
};

const RoleRoute: React.FC<RoleRouteProps> = ({ allowedRoles, children }) => {
  const { user } = useAuth();

  if (!user) return <Navigate to="/login" replace />;

  if (!allowedRoles.includes(user.role as Role)) {
    return <Navigate to={defaultDashboard(user.role)} replace />;
  }

  return children;
};

export default RoleRoute;
